import { BreadcrumbContext } from '@Components/UI/Layout/Layout';
import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';
import useRouteGroup from '@Hooks/Routes/useRouteGroup';
import React, { useContext, useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RoleTable from './RoleTable';

const Roles: React.FC = () => {
	const routeGroup = useRouteGroup('roles');

	const { path, url } = useRouteMatch();
	const { isCurrent } = useInvalidateRouteGroup({
		mode: 'end',
		baseURL: '/dashboard/roles',
		routeGroup: routeGroup,
		routePlacement: 2,
	});

	return (
		<>
			<Switch>
				{routeGroup && !Array.isArray(routeGroup) && (
					<>
						<Route exact path={url}>
							<RoleTable />
						</Route>

						{routeGroup.routes.map((_) => {
							return (
								<Route strict path={`${path}/${_.route}`}>
									{_.component}
								</Route>
							);
						})}
					</>
				)}
			</Switch>
		</>
	);
};

export default Roles;
